module.exports = __webpack_public_path__ + "static/img/product07-3.ab1e50d5.png";